<template>
  <footer class="footer">
    <div class="footer_container">
      font by <a href="http://sozaiya405.chu.jp/405/" title="「素材屋405番地」" target="_blank">「素材屋405番地」 </a>
      <br>
      illust by <a href="http://www.irasutoya.com/" title="いらすとや" target="_blank">いらすとや</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
}

</script>

<style>
.footer {
  height: 50px;
}
.footer_container {
      border-top: solid #eee 1px;
    /* margin-top: 40px;
    padding-bottom: 40px;
    padding-top: 40px; */
}

</style>



// WEBPACK FOOTER //
// AppFooter.vue?3035f46a